module.exports = __webpack_public_path__ + "img/dot-orange.dff5ac76.svg";